import MessagesIndexPage from '../pages/messages-index.vue'
import MessagesNewPage from '../pages/messages-new.vue'
import MessagesShowPage from '../pages/messages-show.vue'

export default [
  {
    component: MessagesIndexPage,
    name: 'messaging.index',
    path: '/:slug/messaging',
  },
  {
    component: MessagesNewPage,
    name: 'messaging.new',
    path: '/:slug/messaging/new',
  },
  {
    component: MessagesShowPage,
    name: 'messaging.show',
    path: '/:slug/messaging/:id',
  },
]
